import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import LocalTexts from '../../../../HomepageTexts.json';

import styles from './HeroContent.scss';

const LocalT = new MDText(LocalTexts);
const t = (key: string, props?: { [key:string]: unknown }) => LocalT.translate(key, props) as string;

export const TEXTS = {
  subTitle: t('hero.subTitle'),
  title: t('hero.title'),
};

type HeroContentProps = {
  className?: string;
  customTitle?: React.ReactNode;
  subTitle?: React.ReactNode;
  title?: React.ReactNode;
  titleSecondary?: React.ReactNode;
}

export const HeroContent = ({
  className,
  customTitle,
  subTitle = TEXTS.subTitle,
  title = TEXTS.title,
  titleSecondary = null,
}: HeroContentProps) => (
  <div className={cx(styles.component, className)}>
    <div className={styles.title}>
      <h1>{title}</h1>{titleSecondary && <br />}
      {titleSecondary}
    </div>
    <div className={styles.heroSubTitleWrapper}>
      <p className={styles.description} data-cy="homepageHeroVRM">
        {customTitle ?? subTitle}
      </p>
    </div>
  </div>
);
